module.exports = __webpack_public_path__ + "img/article_1_2.37e4e965.png";